module.exports = __webpack_public_path__ + "img/PINTURA.addf059c.png";